import { Icon, IconProps } from '@chakra-ui/react'

export function RightLongArrowIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 30 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.8125 10.3329V11.3012H20.8828V14.206L26.7266 10.8171L20.8828 7.42816V10.3329H4.8125Z"
        fill="currentColor"
      />
    </Icon>
  )
}
